export default "__VITE_PUBLIC_ASSET__b137e122__"